import LoadingScreen from 'components/LoadingScreen';
import moment from 'moment';
import React from 'react';
import { Button, Col, Row, Table } from 'reactstrap';

import { BPAFindingAgeCycle } from '../../types/bpaFindings.types';

interface BPAFindingAgeHistoryTabProps {
  error: string;
  isLoading: boolean;
  items: BPAFindingAgeCycle[];
  onRetry: () => void;
}

const BPAFindingAgeHistoryTab: React.FC<BPAFindingAgeHistoryTabProps> = ({
  error,
  isLoading,
  items,
  onRetry,
}) => {
  return (
    <Row>
      <Col>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}{' '}
            <Button size="sm" onClick={onRetry}>
              Retry
            </Button>
          </div>
        )}
        <Table className="tablesorter table-striped" responsive>
          <thead className="text-primary">
            <tr>
              <th>#</th>
              <th>Open Status</th>
              <th>Open Date</th>
              <th>Close Status</th>
              <th>Close Date</th>
              <th style={{ textAlign: 'right' }}>Age (Days)</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={6}>
                  <LoadingScreen />
                </td>
              </tr>
            )}
            {!isLoading && !error && items.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  No age history is available for this finding.
                </td>
              </tr>
            )}
            {!isLoading &&
              !error &&
              items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.open_status}</td>
                  <td>{moment(item.open_date).format('lll')}</td>
                  <td>{item.close_status || '-'}</td>
                  <td>
                    {item.close_date
                      ? moment(item.close_date).format('lll')
                      : '-'}
                  </td>
                  <td className="text-right">{item.age_days.toFixed(1)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default BPAFindingAgeHistoryTab;
